import React from 'react'

const ReeferDetailsContext = React.createContext()

export default ReeferDetailsContext
